import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import type AccountingPaymentModel from './accounting-payment.ts';
import type AccountingInvoiceModel from './accounting-invoice.ts';
import type AccountingLineItemModel from './accounting-line-item.ts';
import type EmployeeModel from './employee.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class AccountingTransactionModel extends Model {
  @attr declare description: string;
  @attr declare state: string;
  @attr declare amount: number;
  @attr declare transactionDate: string;
  @attr declare isCheck: boolean;
  @attr declare checkNumber: string;
  @attr declare creditor: string;
  @attr declare creditorAddress: Record<string, string>;
  @attr declare servicer: string;
  @attr declare employeeName: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('accounting-payment', { async: false, inverse: null })
  declare accountingPayment: AccountingPaymentModel;

  @belongsTo('accounting-invoice', { async: false, inverse: null })
  declare accountingInvoice: AccountingInvoiceModel;

  @belongsTo('accounting-line-item', { async: false, inverse: null })
  declare accountingLineItem: AccountingLineItemModel;

  @belongsTo('employee', { async: false, inverse: null })
  declare employee: EmployeeModel;

  [Type] = 'accounting-transaction';
}
